import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'

import { type ShipmentOrderInputHistoryListEntity } from '@/libs/api'
import { selectedDcIdAtom } from '@/routes/_protected/$tenantKey/-states'

import { getShipmentOrderHistoriesSelectQueryOptions } from '../query-options/get-shipment-order-histories-select-query-option'

/**
 * Select用の配送依頼履歴一覧のUseQuery
 */
export const useShipmentOrderHistoriesSelectQuery = (
  tenantKey: string,
  options?: {
    originSiteId?: number
    destSiteId?: number
    shipmentCategoryId?: number
    customerId?: number
    disabled?: boolean
  }
): UseQueryResult<ShipmentOrderInputHistoryListEntity[]> => {
  const disabled = options?.disabled ?? false
  const selectedDcId = useAtomValue(selectedDcIdAtom)

  return useQuery<ShipmentOrderInputHistoryListEntity[]>({
    ...getShipmentOrderHistoriesSelectQueryOptions(tenantKey, selectedDcId, {
      originSiteId: options?.originSiteId,
      destSiteId: options?.destSiteId,
      shipmentCategoryId: options?.shipmentCategoryId,
      customerId: options?.customerId
    }),
    enabled: !disabled,
    retry: false
  })
}
